import { render, staticRenderFns } from "./DeleteUserForm.vue?vue&type=template&id=6351cccc&"
import script from "./DeleteUserForm.vue?vue&type=script&lang=js&"
export * from "./DeleteUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports